import React from 'react';
import {Badge} from "antd";
import {useProject} from "../../../providers/ClientProjectProvider";

const FixedFeeScopingForm = (props) => {
    const {
        project,
        isProjectUpdating,
        postUpdate
    } = useProject();

    const confirmScopeCallCompleted = async (checked) => {
        if (project.hasCompletedProjectScopeCall()) {
            return TB.toast("Project Scope Call already completed.", {theme: 'danger'})
        }
        let updates = {scope_call_logged_at: new Date()};
        let title = 'Log Client Scope Call As Complete'
        let message = 'Press Ok to log the scope call as completed.'
        if (!project.hasRequestedProjectScopeCall()) {
            title = 'Scope Call Not Requested Yet'
            message = 'The client has not requested a scope call yet. ' + message;
            updates.scope_call_requested_at = new Date();
        }
        let confirm = await TB.alert('warning', title, message, [
            {title: 'Ok'},
            {title: 'Cancel'},
        ]);

        if (!confirm) {
            return;
        }

        let response = await postUpdate(updates);
        if (response && response.scope_call_logged_at) {
            return TB.alert('success', 'Project Scope Call Completed', 'The project is now waiting for final scope approval.', [
                {title: 'Ok'},
            ]);
        } else if (response && !response.scope_call_logged_at) {
            return TB.toast('Project Scope no longer confirmed')
        }
    }

    const confirmProjectScope = async (checked) => {
        if (project.hasConfirmedProjectScope()) {
            return TB.toast("Project Scope already confirmed.", {theme: 'danger'})
        }
        let updates = {scope_confirmed_at: new Date()};

        let title = 'Confirm Project Scope'
        let message = 'Are you sure you want to confirm the project scope and allow the client to invite teams?'
        if (project.isBYO() && TB.find(project.positions, pos => !pos.hasValidFixedFeeDeliverables())) {
            return TB.alert('warning', "Project Scope Not Finished",
                "There are roles with deliverables that haven't been scoped correctly based on pricing strategy. " +
                "Please use the tabs on the left to update each role's scoped deliverables", [
                    {title: 'Ok'},
                ]);
        }

        if (!project.hasRequestedProjectScopeCall()) {
            title = 'Scope Call Not Requested Yet'
            message = 'The client has not requested a scope call yet. ' + message;
            updates.scope_call_requested_at = new Date();
            updates.scope_call_logged_at = new Date();
        } else if (!project.hasCompletedProjectScopeCall()) {
            title = 'Scope Call Not Completed Yet'
            message = 'The scope call has not been logged as completed yet. ' + message;
            updates.scope_call_logged_at = new Date();
        }
        let confirm = await TB.alert('warning', title, message, [
            {title: 'Yes, Continue'},
            {title: 'Cancel'},
        ]);

        if (!confirm) {
            return;
        }

        let response = await postUpdate(updates);
        if (response && response.scope_confirmed_at) {
            return TB.alert('success', 'Project Scope Confirmed',
                'The client can now request proposals from teams.', [
                {title: 'Ok'},
            ]);
        } else if (response && !response.scope_confirmed_at) {
            return TB.toast('Project Scope no longer confirmed')
        }

    }
    return (
        <React.Fragment>
            <div className="flex flex-col gap-1.5 items-stretch">
                <p className="text-xs font-semibold flex flex-row gap-1.5 items-center">
                    Client Scoping Call
                </p>
                <div className="flex flex-row gap-3 items-center justify-between">
                    <p className={TB.mapClass("text-lg", {
                        "pointer-events-none": isProjectUpdating
                    })}>
                        {project.hasCompletedProjectScopeCall() ? (
                            <Badge size="large" count="Completed" showZero color={TB.config('color.success')}/>
                        ) : !project.hasRequestedProjectScopeCall() ? (
                            <Badge size="large" count="Not Requested" showZero color="#b3b3b3"/>
                        ) : (
                            <Badge size="large" count="Pending" showZero color={TB.config('color.warning')}/>
                        )}
                    </p>
                    {!project.hasCompletedProjectScopeCall() && (
                        <button disabled={isProjectUpdating}
                                onClick={confirmScopeCallCompleted}
                                className="btn btn-link btn-link-primary py-0 px-0">
                            Mark as Complete
                        </button>
                    )}

                </div>

            </div>
            <div className="flex flex-col gap-1.5 items-stretch">
                <p className="text-xs font-semibold flex flex-row gap-1.5 items-center">
                    Project Scope
                </p>
                <div className="flex flex-row gap-3 items-center justify-between">
                    <p className={TB.mapClass("text-lg", {
                        "pointer-events-none": isProjectUpdating
                    })}>
                        {!project.hasConfirmedProjectScope() ? (
                            <Badge size="large" count="Incomplete" showZero color={TB.config('color.warning')}/>
                        ) : (
                            <Badge size="large" count="Complete, Open to Proposals" showZero color={TB.config('color.secondary')}/>
                        )}
                    </p>
                    {!project.hasConfirmedProjectScope() && (
                        <button disabled={isProjectUpdating} onClick={confirmProjectScope}
                                className="btn btn-link btn-link-primary py-0 px-0">
                            Mark as Complete
                        </button>
                    )}

                </div>
            </div>
        </React.Fragment>
    )
};

export default FixedFeeScopingForm;